import React from 'react';
import PropTypes from 'prop-types';
import Plotly from 'plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
import { useSelector } from 'react-redux';
import formatNumberWithAbbreviation from '../../utils/numberMeasurementFormat';

const Plot = createPlotlyComponent(Plotly);

const EpTendencyChart = ({
  xaxisValues, yaxisValues, culture,
}) => {
  const lastFiltersApplied = useSelector(state => state.filter.lastFiltersApplied);
  const filterIndicatorSelected = lastFiltersApplied.indicator;

  const chartConfig = {
    responsive: true,
    displaylogo: false,
    toImageButtonOptions: { responsive: true },
    modeBarButtonsToRemove: [
      'zoom2d',
      'pan2d',
      'select2d',
      'lasso2d',
      'zoomIn2d',
      'zoomOut2d',
      'autoScale2d',
      'toggleSpikelines',
      'hoverClosestCartesian',
      'hoverCompareCartesian',
      'resetScale2d',
      'toImage',
    ],
  };

  const chartData = [{
    x: xaxisValues,
    y: yaxisValues,
    type: 'scatter',
    mode: 'lines',
    line: {
      color: 'rgb(66, 133, 244)',
      width: 1,
      shape: 'linear',
      dash: 'solid',
      simplify: true,
    },
    fill: 'tonexty',
    fillcolor: 'rgb(232, 240, 254)',
    hovertext: [],
    hoverinfo: 'text', // opção de hover personalizado
  }];

  const chartLayout = {
    font: {
      color: 'rgba(110, 124, 147, 1)',
      family: 'Poppins, sans-serif',
      size: 12,
    },
    xaxis: {
      showticklabels: false,
      showgrid: false,
      fixedrange: true,
    },
    yaxis: {
      showticklabels: false,
      showgrid: false,
      fixedrange: true,
    },
    autosize: true,
    margin: {
      l: 0,
      r: 0,
      b: 0,
      t: 0,
    },
    plot_bgcolor: 'rgba(255, 255, 255, 0)',
    paper_bgcolor: 'rgba(255, 255, 255, 0)',
  };

  const linePointsLength = xaxisValues.length;

  for (let i = 0; i < linePointsLength; i++) {
    const currentXaxisValues = xaxisValues[i];
    let currentYaxisValues = formatNumberWithAbbreviation(yaxisValues[i], 0, culture);

    // Dependendo do tipo de grupo do paciente, a quantidade de casas decimais é alterada
    if (filterIndicatorSelected === 2 || filterIndicatorSelected === 4
      || filterIndicatorSelected === 7 || filterIndicatorSelected === 8
      || filterIndicatorSelected === 9) {
      currentYaxisValues = formatNumberWithAbbreviation(yaxisValues[i], 1, culture);
    }

    chartData[0].hovertext = [...chartData[0].hovertext, `${currentXaxisValues} - ${currentYaxisValues}`];
  }

  return (
    <Plot
      config={chartConfig}
      data={chartData}
      layout={chartLayout}
      style={{ width: '100%', height: '100%' }}
      useResizeHandler
    />
  );
};

export default EpTendencyChart;

EpTendencyChart.defaultProps = {
  xaxisValues: [],
  yaxisValues: [],
  culture: 'en-US',
};

EpTendencyChart.propTypes = {
  xaxisValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  yaxisValues: PropTypes.arrayOf(PropTypes.number),
  culture: PropTypes.string,
};
